import Footer from "./components/footer/footer";
import Header from "./components/header/header";
import LeftPanel from "./components/leftPanel/leftPanel";
import Main from "./components/main/main";
import Pages from "./page/pages";

function App() {
  return (
    <div className="App">
      <Pages/>
    </div>
  );
}

export default App;
